import PollResultsModal from "./PollResultsModal";
export default PollResultsModal;
